import styled from "styled-components";
import {Container} from "../../theme/elements";

export const HeaderContainer= styled.div`
    background-color: #0b0c0c;
    width: 100%;
    padding: 14px 20px 4px;
    position: relative;

    img {
      width: 153px;
    }
   
    @media (min-width: 992px) {
         height: 69px;
    }
`

export const InnerWrapper = styled(Container)`
    display: flex;
    justify-content: space-between;;
`
export const SearchForm = styled.form` 
  width: 100%;
  display: none;
  
   @media (min-width: 992px) {
         display: block;
         width: 40%;
    }
`

